import api from "@/lib/axios";
import { publicApi } from "@/lib/axios";

export const invitationService = {
  async sendInvitations(invitations) {
    const response = await api.post('/v1/send-invitations', {
      invitations
    });
    return response.data;
  },

  // Verify invitee token (public endpoint)
  async verifyInviteeToken(token) {
    const response = await publicApi.post('/register-invitee', {
      token
    });
    // Store the verification response data for later use
    localStorage.setItem('verificationData', JSON.stringify(response.data));
    return response.data;
  },

  // Submit invitee questions (public endpoint)
  async submitQuestions(data) {
    // The data object will contain:
    // - questions: array of question objects, each with optional id for existing questions
    // - contributor: { name, relationship }
    // - email: user's email (if available)
    const response = await publicApi.post('/submit-question', data);
    return response.data;
  },

  // Delete a question
  async deleteQuestion(questionId) {
    const response = await publicApi.post('/delete-question', {
      id: questionId
    });
    return response.data;
  }
}; 